import { render, staticRenderFns } from "./personTmpl.vue?vue&type=template&id=567097be&scoped=true&"
import script from "./personTmpl.vue?vue&type=script&lang=js&"
export * from "./personTmpl.vue?vue&type=script&lang=js&"
import style0 from "./personTmpl.vue?vue&type=style&index=0&id=567097be&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567097be",
  null
  
)

export default component.exports